import useUpdateProduct from "hooks/useUpdateProduct";
import { MdClose, MdDelete } from "react-icons/md";
import ReactQuill from "react-quill-new";
import "react-quill/dist/quill.snow.css";

const EditProductModal = ({
  showEditProduct,
  onProductUpdated,
  toggleEditProduct,
  productId,
}) => {
  const {
    isFeatured,
    setIsFeatured,
    isbestselling,
    setIsbestselling,
    isPercentage,
    setIsPercentage,
    productName,
    setProductName,
    productDescription,
    setProductHighlightedText,
    productHighlightedText,
    setProductDescription,
    productSKU,
    setProductSKU,
    productImeiList,
    setProductImeiList,
    productCategory,
    setProductCategory,
    customerPrice,
    setCustomerPrice,
    retailerPrice,
    setRetailerPrice,
    distributorPrice,
    setDistributorPrice,
    corporateClientPrice,
    setCorporateClientPrice,
    quantity,
    setQuantity,
    productDiscount,
    setProductDiscount,
    retailerPercentage,
    setRetailerPercentage,
    distributorPercentage,
    setDistributorPercentage,
    corporatePercentage,
    setCorporatePercentage,
    bannerImages,
    setBannerImages,
    productimages,
    setProductImages,
    newAddedproductimages,
    setNewAddedproductimages,
    newAddedBannerimages,
    setNewAddedBannerimages,
    selectedSpecs,
    setSelectedSpecs,
    specifications,
    setSpecifications,
    sizes,
    setSizes,
    colors,
    setColors,
    colorImages,
    setColorImages,
    categories,
    setCategories,
    handleSubmit,
    handleColorImageChange,
    handleRemoveColorImage,
    handleNewProductImagesChange,
    removeProductImage,
    handleRemoveSpecification,
    handleAddSpecification,
    handleSpecInputChange,
    handleImeiChange,
    handlePercentageInput,
    handleNewBannerImagesChange,
    removeBannerImage,
    closingModal,
    specsField,
    specInputs,
    resetFormFields,
  } = useUpdateProduct(productId, onProductUpdated, toggleEditProduct);

  //react quill
  const modules = {
    toolbar: [
      [{ list: "bullet" }, { list: "ordered" }],
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ align: [] }],
      ["bold", "italic", "underline"],
      ["link"],
    ],
  };

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-navy-900 opacity-50"
        onClick={toggleEditProduct}
      ></div>

      <div
        className={`fixed right-0 top-0 h-screen w-2/3 transform bg-white transition-transform ${
          showEditProduct ? "translate-x-0" : "translate-x-full"
        } z-50 shadow-lg`}
      >
        <div className="flex h-full flex-col bg-navy-700">
          <div className="flex items-center justify-between bg-gray-500 p-3 shadow-md">
            <div className="flex-col">
              <h1 className="text-xl">Edit Product</h1>
              <h1 className="text-lg">
                Edit your product and necessary information from here
              </h1>
            </div>
            <MdClose
              className="cursor-pointer rounded-full bg-navy-900 p-1 text-3xl text-white"
              onClick={closingModal}
            />
          </div>

          <form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="no-scrollbar h-full flex-col items-center overflow-y-scroll p-5"
          >
            <div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Is Featured</h1>
                <div className="flex items-center">
                  <label className="relative mr-5 inline-flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      className="sr-only text-white"
                      checked={isFeatured}
                      onChange={() => setIsFeatured(!isFeatured)}
                    />
                    <div
                      className={`h-6 w-12 rounded-full transition-colors ${
                        isFeatured ? "bg-primary" : "bg-gray-300"
                      }`}
                    ></div>
                    <div
                      className={`absolute left-1 top-1 h-4 w-4 transform rounded-full bg-white transition-transform ${
                        isFeatured ? "translate-x-6" : "translate-x-0"
                      }`}
                    ></div>
                  </label>
                  <span className="ml-3 text-left text-sm text-white">
                    {isFeatured ? "Featured" : "Not Featured"}
                  </span>
                </div>
              </div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Is Best Selling</h1>
                <div className="flex items-center">
                  <label className="relative mr-5 inline-flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      className="sr-only text-white"
                      checked={isbestselling}
                      onChange={() => setIsbestselling(!isbestselling)}
                    />
                    <div
                      className={`h-6 w-12 rounded-full transition-colors ${
                        isbestselling ? "bg-primary" : "bg-gray-300"
                      }`}
                    ></div>
                    <div
                      className={`absolute left-1 top-1 h-4 w-4 transform rounded-full bg-white transition-transform ${
                        isbestselling ? "translate-x-6" : "translate-x-0"
                      }`}
                    ></div>
                  </label>
                  <span className="ml-0 text-left text-sm text-white">
                    {isbestselling ? "Best Selling" : "Not Enabled"}
                  </span>
                </div>
              </div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Product Title/Name</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Product Title/Name"
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Highlighted Product Text
                </h1>
                <ReactQuill
                  className="text-black w-3/5 rounded-md bg-white p-2"
                  placeholder="Highlighted Product Text"
                  value={productHighlightedText}
                  onChange={(content, delta, source, editor) => {
                    setProductHighlightedText(editor.getHTML());
                  }}
                  modules={modules}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Product Description
                </h1>
                <ReactQuill
                  className="text-black w-3/5 rounded-md bg-white p-2"
                  placeholder="Product Description"
                  value={productDescription}
                  onChange={(content, delta, source, editor) => {
                    setProductDescription(editor.getHTML());
                  }}
                  modules={modules}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Sizes</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Enter sizes (comma separated)"
                  value={sizes.join(",")}
                  onChange={(e) =>
                    setSizes(e.target.value.split(",").map((s) => s.trim()))
                  }
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Colors</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Enter colors (comma separated)"
                  value={colors.join(",")}
                  onChange={(e) => {
                    const colorArr = e.target.value
                      .split(",")
                      .map((c) => c.trim());
                    setColors(colorArr);

                    // Also re-initialize colorImages if needed:
                    setColorImages((prev) => {
                      const newObj = { ...prev };
                      Object.keys(newObj).forEach((existingColor) => {
                        if (!colorArr.includes(existingColor)) {
                          delete newObj[existingColor];
                        }
                      });
                      colorArr.forEach((c) => {
                        if (!newObj[c]) {
                          newObj[c] = [];
                        }
                      });
                      return newObj;
                    });
                  }}
                />
              </div>

              {colors.map((color) => (
                <div key={color} className="mb-5">
                  <h1 className="text-lg text-white">Images for {color}</h1>
                  <input
                    className="rounded-md p-2 text-white"
                    type="file"
                    multiple
                    accept=".jpeg, .jpg, .png .gif .mp4 .mov .webm .mkv"
                    onChange={(e) => handleColorImageChange(e, color)}
                  />
                  <div className="mt-2 flex flex-wrap gap-2">
                    {(colorImages[color] || []).map((imgObj, idx) => {
                      const previewUrl = imgObj.preview
                        ? imgObj.preview
                        : `${process.env.REACT_APP_API_URL_Plain}/config/uploads/products/product_images/${colorImages[color][idx]}`;

                      console.log(colorImages[color][idx]);
                      return (
                        <div key={idx} className="relative">
                          <img
                            src={previewUrl}
                            alt="preview"
                            style={{ width: "100px", height: "100px" }}
                          />
                          <MdDelete
                            className="absolute right-0 top-0 cursor-pointer rounded-full bg-red-500 p-1 text-xl text-white"
                            onClick={() => handleRemoveColorImage(color, idx)}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}

              <div className="mb-5">
                <h1 className="text-lg text-white">Product Images</h1>
                <input
                  className="rounded-md p-2 text-white"
                  type="file"
                  multiple
                  accept=".jpeg, .jpg, .png .gif .mp4 .mov .webm .mkv"
                  onChange={handleNewProductImagesChange}
                />
                <div className="mt-2 flex flex-wrap gap-2">
                  {productimages.map((img, index) => {
                    const isLocalBlob = img.startsWith("blob:");
                    const src = isLocalBlob
                      ? img
                      : `${process.env.REACT_APP_API_URL_Plain}/config/uploads/products/product_images/${img}`;
                    return (
                      <div key={index} className="relative">
                        <img
                          src={src}
                          alt="preview"
                          className="h-24 w-24 object-cover"
                        />
                        <MdDelete
                          className="absolute right-0 top-0 cursor-pointer rounded-full bg-red-500 p-1 text-xl text-white"
                          onClick={() => removeProductImage(index)}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>

              <div>
                {/* Specifications */}
                <div className="mb-5">
                  <h1 className="text-lg text-white">
                    Selected Specifications
                  </h1>
                  <div className="flex flex-wrap gap-2">
                    {selectedSpecs.map((spec) => (
                      <div
                        key={spec}
                        className="flex items-center rounded-md bg-gray-200 p-2"
                      >
                        <span>{spec}</span>
                        <MdClose
                          className="ml-2 cursor-pointer text-red-500"
                          onClick={() => handleRemoveSpecification(spec)}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Add Product Specification */}
                <div className="mb-5 flex w-full items-center justify-between">
                  <h1 className="w-2/5 text-lg text-white">
                    Add Product Specification
                  </h1>
                  <select
                    className="w-3/5 rounded-md p-2"
                    onChange={handleAddSpecification}
                    value=""
                  >
                    <option value="">Select a Specification</option>
                    {specsField
                      .filter((spec) => !selectedSpecs.includes(spec))
                      .map((spec) => (
                        <option key={spec} value={spec}>
                          {spec}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Input for each selected specification */}
              {selectedSpecs.map((spec) => (
                <div
                  key={spec}
                  className="mb-5 flex w-full items-center justify-between"
                >
                  <h1 className="w-2/5 text-lg text-white">{spec}</h1>
                  <input
                    className="w-3/5 rounded-md p-2"
                    type="text"
                    placeholder={`Enter ${spec}`}
                    value={specInputs[spec] || ""}
                    onChange={(e) =>
                      handleSpecInputChange(spec, e.target.value)
                    }
                  />
                </div>
              ))}

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Product SKU</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Product SKU"
                  value={productSKU}
                  onChange={(e) => setProductSKU(e.target.value)}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Product IMEI</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Product IMEI"
                  value={productImeiList}
                  onChange={handleImeiChange} // Handle IMEI input change
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Product Category</h1>
                <select
                  className="w-3/5 rounded-md p-2"
                  value={productCategory}
                  onChange={(e) => setProductCategory(e.target.value)}
                >
                  <option value="">Select a Category</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Product Price <span>(Customer)</span>
                </h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="number"
                  placeholder="$"
                  value={customerPrice}
                  onChange={(e) => setCustomerPrice(e.target.value)}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Use Percentage For (Retailer, Distributor, Corporate Clients)
                </h1>
                <div className="flex w-3/5 items-center">
                  <label className="relative inline-flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      className="sr-only text-white"
                      checked={isPercentage}
                      onChange={handlePercentageInput}
                    />
                    <div
                      className={`h-6 w-12 rounded-full transition-colors ${
                        isPercentage ? "bg-primary" : "bg-gray-300"
                      }`}
                    ></div>
                    <div
                      className={`absolute left-1 top-1 h-4 w-4 transform rounded-full bg-white transition-transform ${
                        isPercentage ? "translate-x-6" : "translate-x-0"
                      }`}
                    ></div>
                  </label>
                  <span className="ml-3 text-sm text-white">
                    {isPercentage ? "Enabled" : "Disabled"}
                  </span>
                </div>
              </div>

              {isPercentage ? (
                <>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Retailer Percentage
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="%"
                      value={retailerPercentage}
                      onChange={(e) => setRetailerPercentage(e.target.value)}
                    />
                  </div>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Distributor Percentage
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="%"
                      value={distributorPercentage}
                      onChange={(e) => setDistributorPercentage(e.target.value)}
                    />
                  </div>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Corporate Percentage
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="%"
                      value={corporatePercentage}
                      onChange={(e) => setCorporatePercentage(e.target.value)}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Product Price <span>(Retailer)</span>
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="$"
                      value={retailerPrice}
                      onChange={(e) => setRetailerPrice(e.target.value)}
                    />
                  </div>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Product Price <span>(Distributor)</span>
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="$"
                      value={distributorPrice}
                      onChange={(e) => setDistributorPrice(e.target.value)}
                    />
                  </div>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Product Price <span>(Corporate Clients)</span>
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="$"
                      value={corporateClientPrice}
                      onChange={(e) => setCorporateClientPrice(e.target.value)}
                    />
                  </div>
                </>
              )}

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Product Quantity</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="number"
                  placeholder="0"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Product Discount</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="number"
                  placeholder="0"
                  value={productDiscount}
                  onChange={(e) => setProductDiscount(e.target.value)}
                />
              </div>

              <div className="mb-5">
                <h1 className="text-lg text-white">Banner Photos</h1>
                <input
                  className="rounded-md p-2 text-white"
                  type="file"
                  multiple
                  accept=".jpeg, .jpg, .png .gif .mp4 .mov .webm .mkv"
                  onChange={handleNewBannerImagesChange}
                />
                <div className="mt-2 flex flex-wrap gap-2">
                  {bannerImages.map((img, index) => {
                    const isLocalBlob = img.startsWith("blob:");
                    const src = isLocalBlob
                      ? img
                      : `${process.env.REACT_APP_API_URL_Plain}/config/uploads/products/banner_images/${img}`;
                    return (
                      <div key={index} className="relative">
                        <img
                          src={src}
                          alt="preview"
                          style={{ width: "100px", height: "100px" }}
                        />
                        <MdDelete
                          className="absolute right-0 top-0 cursor-pointer rounded-full bg-red-500 p-1 text-xl text-white"
                          onClick={() => removeBannerImage(index)}
                        />
                      </div>
                    );
                  })}
                </div>

                <div className="mt-2 flex flex-wrap gap-2">
                  <button
                    type="submit"
                    className="w-full rounded-md bg-primary p-2 text-lg text-primaryText"
                  >
                    Update Product
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditProductModal;
